import { ReactComponent as SentIcon } from './sent.svg';

export default SentIcon;
